import { createAction, type QueuedAction } from "@/v2/hooks/useActionQueue";
import { apiCall, type ActionDeps } from "./types";

export function resolveFeedbackAction(entryId: number, deps: ActionDeps): QueuedAction {
	const rollback = deps.updateEntries((prev) =>
		prev.map((e) =>
			e.id === entryId ? { ...e, attorney_feedback: null, needs_improvement: false } : e,
		),
	);

	return createAction({
		execute: () =>
			apiCall(deps, {
				endpoint: `/records/${entryId}/resolve-feedback`,
				method: "POST",
			}),
		rollback,
		toast: {
			loading: "Resolving feedback…",
			success: "Feedback resolved",
			error: "Failed to resolve feedback",
		},
		onSuccess: () => deps.refreshRecords(),
		onError: () => deps.refreshRecords(),
	});
}
